import { useMemo } from 'react';
import type { SelectValue } from '@shared/ui/select';
import type { PreviewChannelItem } from './preview-channels';
import { buildInvitationDeliveryPreviewChannels, buildTicketDeliveryPreviewChannels } from './sms-cost-preview';

export interface PreviewChannels {
  invitationChannels: PreviewChannelItem[];
  ticketChannels: PreviewChannelItem[];
}

export interface PreviewChannelsParams {
  emailCount: number;
  smsCount: number;
  vkCount: number;
  invitation: {
    selectedChannels: SelectValue[];
    isOutlookMeetingEnabled: boolean;
    textParts: number;
  };
  ticket: {
    selectedChannels: SelectValue[];
    isSettingsCollapsed: boolean;
    textParts: number;
  };
}

export const usePreviewChannels = (params: PreviewChannelsParams): PreviewChannels => {
  const {
    emailCount,
    smsCount,
    vkCount,
    invitation: { selectedChannels, isOutlookMeetingEnabled, textParts: invitationTextParts },
    ticket: {
      selectedChannels: selectedTicketChannels,
      isSettingsCollapsed: isTicketSettingsCollapsed,
      textParts: ticketTextParts,
    },
  } = params;

  return useMemo(
    () => ({
      invitationChannels: buildInvitationDeliveryPreviewChannels(
        selectedChannels,
        emailCount,
        smsCount,
        vkCount,
        isOutlookMeetingEnabled,
        invitationTextParts
      ),
      ticketChannels: buildTicketDeliveryPreviewChannels(
        selectedTicketChannels,
        emailCount,
        smsCount,
        vkCount,
        isTicketSettingsCollapsed,
        ticketTextParts
      ),
    }),
    [
      emailCount,
      smsCount,
      vkCount,
      selectedChannels,
      isOutlookMeetingEnabled,
      invitationTextParts,
      selectedTicketChannels,
      isTicketSettingsCollapsed,
      ticketTextParts,
    ]
  );
};
